import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';

@Component({
  selector: 'app-test-tool-guide',
  templateUrl: './test-tool-guide.component.html',
  styleUrls: ['./test-tool-guide.component.scss']
})
export class TestToolGuideComponent implements OnInit {

 constructor(
    private router: Router,
    private location: Location,
    private store: Store
  ) { }

  public ngOnInit(): void {
    window.open('https://support.lbmx.com/hc/en-us/articles/15000469430804-LBMX-Guide-How-do-I-use-the-Automated-Testing-Tool-', '_blank');
    this.location.back();
  }
}
